import { BreadcrumbItem, selectedProjectType } from './../../../common/sub-header/sub-header.component';
import { HeaderTitle } from './../../../common/header-title/header-title.model';
import { Subscription } from 'rxjs';
import { HeaderTitleService } from '@app/shared/common/header-title/header-title.service';
import { Injector, Component, OnInit, Inject, ChangeDetectorRef, OnDestroy, ViewChild, AfterViewInit, Input } from '@angular/core';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { ThemesLayoutBaseComponent } from '@app/shared/layout/themes/themes-layout-base.component';
import { UrlHelper } from '@shared/helpers/UrlHelper';
import { DOCUMENT } from '@angular/common';
import { OffcanvasOptions } from '@metronic/app/core/_base/layout/directives/offcanvas.directive';
import { AppConsts } from '@shared/AppConsts';
import { ToggleOptions } from '@metronic/app/core/_base/layout/directives/toggle.directive';
import { DateTimeService } from '@app/shared/common/timing/date-time.service';
import { Router } from '@angular/router';
import { SettingTopbarComponent } from '../../topbar/setting-topbar/setting-topbar.component';
import { ClientContactCreateOrEditDto, ClientCreateOrEditDto, ClientDto, ClientServiceProxy, ClientType, MyProfileOutput, ProfileServiceProxy, ProjectServiceProxy, ProjectType, UserLoginServiceProxy, UserServiceProxy } from '../../../../../shared/service-proxies/service-proxies';
import { AbpSessionService } from 'abp-ng2-module';
import { ProjectsNewComponent } from '@app/main/projects-new/projects-new.component';
import { ClientNewComponent } from '@app/main/client-new/client-new.component';
import { ClientDropServiceService } from './client-drop-service.service';
import { ClientNameService } from './client-name.service';
import { name } from 'msal/lib-commonjs/packageMetadata';
import { style } from '@angular/animations';
import { ProjectDropServiceService } from './project-drop-service.service';
import { Console } from 'console';
import { IsUserType } from '@shared/service-proxies/service-proxies';

import { DefaultLayoutService } from './default-layout.service';
import { ProductsAndServicesTabsNewService } from '@app/main/products-and-services-new/products-and-services-tabs-new/products-and-service-tabs.service';


import { finalize } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import * as _ from 'lodash';
import { AppSessionService } from '@shared/common/session/app-session.service';
import { DefaultBrandComponent } from './default-brand.component';
// import { DefaultLayoutService } from './default-layout.service';
// import { ProductsAndServicesTabsNewService } from '@app/main/products-and-services-new/products-and-services-tabs-new/products-and-services-tabs-new.service';
@Component({
    templateUrl: './default-layout.component.html',
    selector: 'default-layout',
    animations: [appModuleAnimation()],

})
export class DefaultLayoutComponent extends ThemesLayoutBaseComponent implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild(SettingTopbarComponent) child: SettingTopbarComponent;
    @ViewChild(ProjectsNewComponent) projectChild: ProjectsNewComponent;
    @ViewChild(ClientNewComponent) clientChild: ClientNewComponent;
    @ViewChild(DefaultBrandComponent) defaultBrand: DefaultBrandComponent;




    clientType = ClientType;

    clientSelectedHeading = "ActiveClients";
    uparrow = true;
    clientId: number;
    option: number;
    isProfileData: boolean = false;

    projectSelectedHeading = "ActiveProjects";

    projType: number;
    newProjTabs: number[] = [];


    clientData: ClientCreateOrEditDto = new ClientCreateOrEditDto();
    clientContactData: ClientContactCreateOrEditDto[] = [];
    primaryContactList: ClientContactCreateOrEditDto[] = [];
    secondaryContactList: ClientContactCreateOrEditDto[] = [];
    breadcrumbs: BreadcrumbItem[];
    selectedProjectTypes: selectedProjectType[];
    pageTitleSub: Subscription;

    productServiceSelectionTypeValue: string = 'Products';
    productServiceSelectedTab = 1;
    productSelectionDropdownValue = 'ActiveProducts';
    serviceSelectionDropdownValue = 'ActiveServices';
    userSelectedType = 'activeUsers';
    dashboardSelectedType = 'MyDashboard';
    textForClass: string = 'la-angle-down';





    menuCanvasOptions: OffcanvasOptions = {
        baseClass: 'aside',
        overlay: true,
        closeBy: 'kt_aside_close_btn',
        toggleBy: 'kt_aside_mobile_toggle'
    };

    userMenuToggleOptions: ToggleOptions = {
        target: this.document.body,
        targetState: 'topbar-mobile-on',
        toggleState: 'active'
    };
    isClient = false;
    remoteServiceBaseUrl: string = AppConsts.remoteServiceBaseUrl;
    isLoginForFirstTime: boolean = false;
    checkLogin: string;
    isVisible: boolean = true;
    tabIndexFinal: any;
    tabIndex: any;
    clientName: any;
    routerLink: any;
    event = this._clientNameService.getCardList();
    myProfileRole: any;
    isCheckProfile: boolean = false;
    isuserDetailsPage: boolean = false;

    projectType: ProjectType = ProjectType.AllProjects;
    FirstTimeLoginCheck: string;

    webAppVersion: string;

    constructor(
        injector: Injector,
        @Inject(DOCUMENT) private document: Document,
        _dateTimeService: DateTimeService,
        private _clientNameService: ClientNameService,
        private _client_drop_service: ClientDropServiceService,
        private _projectDropService: ProjectDropServiceService,
        private _userService: UserServiceProxy,
        private _projectServiceProxy: ProjectServiceProxy,
        private _profileService: ProfileServiceProxy,
        private _abpSessionServiceProxy: AbpSessionService,
        private _appSession: AppSessionService,
        private headerTitleService: HeaderTitleService,
        private cdRef: ChangeDetectorRef,
        private router: Router,
        private _userLoginAppService: UserLoginServiceProxy,
        // private _userServiceProxy: UserServiceProxy,
        // private _defaultLayoutService: DefaultLayoutService,
        // private _productsAndServicesTabsNewService: ProductsAndServicesTabsNewService,
        // private _clientServiceProxy: ClientServiceProxy,


        private _userServiceProxy: UserServiceProxy,
        private _spinnerService: NgxSpinnerService,
        private _clientServiceProxy: ClientServiceProxy,
        public _defaultLayoutService: DefaultLayoutService,
        private _productsAndServicesTabsNewService: ProductsAndServicesTabsNewService
    ) {
        super(injector, _dateTimeService);

    }


    getProductServiceResponse() {

        this._productsAndServicesTabsNewService.showProductServiceType.subscribe((res: any) => {

            this.productServiceSelectionType(res);

        })
    }



    ngOnInit() {
        this.webAppVersion = this._appSession.webAppVersion;

        abp.event.on('getProductServiceResponse', () => { this.getProductServiceResponse(); });
        // console.log('THeme',this.currentTheme.baseSettings.theme);
        // console.log('Header',this.currentTheme.baseSettings.header)
        let thisObj = this;
        let myProfileDataisChanged = JSON.parse(localStorage.getItem('MyProfileDataSaved'));

        if (AppConsts.myProfileInfo && !myProfileDataisChanged) {
            this.afterMyProfileInfoInitialize(AppConsts.myProfileInfo);
        } else {
            this._profileService.myProfileInfo().subscribe(res => {
                AppConsts.myProfileInfo = res;
                localStorage.setItem('MyProfileDataSaved', 'false');
                this.afterMyProfileInfoInitialize(res);
            });
        }

        abp.event.on('CheckFirstLoginofUser', () => { this.checkLoginForUserToHide(); });


        this.tabIndexFinal = this._clientNameService.getCardList();
        //this.isLoginForFirstTime = JSON.parse(localStorage.getItem('checkLoginSuccess')) == undefined || JSON.parse(localStorage.getItem('checkLoginSuccess')) === true ? false : true;
        abp.event.on('checkLoginSuccessFordefault', function () { thisObj.userQuickStartDetailsCheck(); });
        this.isLoginForFirstTime = JSON.parse(localStorage.getItem('checkLoginSuccess'));

        //this.userQuickStartDetailsCheck();

        this.isCheckForClientUser();


        this.installationMode = UrlHelper.isInstallUrl(location.href);
        this.pageTitleSub = this.headerTitleService.getPageTitle().subscribe((res: HeaderTitle) => {
            if (this.router.url.includes('/app/admin/invite-userprofile')) {
                this.isuserDetailsPage = true;
            }
            if (this.router.url.includes('/app/admin/new-invite-user')) {
                this.isuserDetailsPage = true;
            }

            this.breadcrumbs = res.breadcrumbs;

            this.cdRef.detectChanges();
        });


        //this.dashboardChange();

        // this.getClientdata();
    }

    ngAfterViewInit(): void {
        if(!AppConsts.initialLoadSideBar) { AppConsts.initialLoadSideBar = true;
            if(document.body.classList.contains('aside-minimize')) this.defaultBrand.toggleLeftAside();
        }
    }

    checkLoginForUserToHide() {
        this.FirstTimeLoginCheck = JSON.parse(localStorage.getItem('FirstTimeCheck'));

    }
    afterMyProfileInfoInitialize(res) {
        this.isProfileData = true;
        localStorage.setItem('MyProfileData', JSON.stringify(res));
        this.myProfileRole = res.roleName;
        localStorage.setItem('MyProfileDetails', JSON.stringify(res));
        if (this.myProfileRole == 'Employee' || this.myProfileRole == 'Client') {
            this.isCheckProfile = true;
        }
        else {
            this.isCheckProfile = false;
        }
    }



    dashboardChange() {
        let value = 1;
        this._defaultLayoutService.showDashboardType.next(value);
        abp.event.trigger('getDashboardTabChangeResponse');

    }

    userQuickStartDetailsCheck() {
        this.isLoginForFirstTime = JSON.parse(localStorage.getItem('checkLoginSuccess'));
        this.userQuickStartforTopbarDownload();

    }

    onClick(client: string) {
        if (client == this.l("ActiveClients")) {

            this.router.navigate(['/app/main/client-new/client-new-managment']);
        }
        if (client == this.l("ArchivedClients")) {
            this.router.navigate(['/app/main/client-new/client-new-managment']);
        }
        if (client == this.l("ActiveProducts")) {
            this.router.navigate(['/app/main/products-and-services-new'])
        }
        if (client == this.l("ActiveServices")) {
            this.router.navigate(['/app/main/products-and-services-new'])
        }
        if (client == this.l("ActiveProjects")) {

            this.router.navigate(['/app/main/projects-new/projects-new-management']);
        }
        if (client == this.l("ArchivedProjects")) {

            this.router.navigate(['/app/main/projects-new/projects-new-management']);
        }
        if (client == this.l("activeUsers")) {
            this.router.navigate(['/app/admin/users']);
        }
        //   if(client == "Active Projects "){

        //     this.router.navigate(['/app/main/projects-new/projects-new-management']);
        //    }

    }

    userQuickStartforTopbarDownload() {
        abp.event.trigger('checkLoginForTopbardownload');
        abp.event.trigger('checkLoginForTopbarSetting');
    }

    goToBreadcrumb(breadcrumb: BreadcrumbItem): void {
        if (!breadcrumb.routerLink) {
            return;
        }
        if (breadcrumb.navigationExtras) {
            this.router.navigate([breadcrumb.routerLink], breadcrumb.navigationExtras);
        }

        else {
            this.router.navigate([breadcrumb.routerLink]);
        }
    }

    ngOnDestroy() {
        this.pageTitleSub.unsubscribe();
    }
    // Company Profile Data Update in Setting Dropdown
    companyProfileClick() {
        this.child.updateInfoForCompanyProfile();
    }




    selectedTab(value: any) {



        this._client_drop_service.showClientType.next(value);



        abp.event.trigger('getClientResponse');



        if (value === 1) {

            this.clientSelectedHeading = 'ActiveClients';


        }

        if (value === 2) {

            this.clientSelectedHeading = 'ArchivedClients';

        }

        if (value === 3) {

            this.clientSelectedHeading = 'DeletedClients';

        }



    }

    selectedProTab(value: any) {



        this._projectDropService.showProjectType.next(value);



        abp.event.trigger('getProjectResponse');



        if (value === 1) {

            this.clientSelectedHeading = 'ActiveProjects';


        }

        if (value === 2) {

            this.clientSelectedHeading = 'ArchivedProjects';

        }

        if (value === 3) {

            this.clientSelectedHeading = 'DeletedProjects';

        }



    }







    // this.selectedProjects = [];
    // this.isLoading = true;
    // this.emptystate=false;
    // this.addNewDisappear=false;
    // this._projectServiceProxy.getProjectsByUserIds(this.assignedUserIdFilter, ProjectType.AllProjects,this.assignedprojectIdFilter, this.filterText, this.isManager).pipe(finalize(() => {
    //   this.isLoading = false;
    // })).subscribe(res => {

    //     this.projectsData = [];
    //     res.forEach(x => {
    //         if (x.projectImage === '') {
    //             x.projectImage = 'assets/common/images/projects/default image for project -1.png';
    //         }
    //         this.projectsData.push(x);
    //     });
    //     this.IsProjectDataEmpty = this.projectsData.length ? false : true;
    //     if(res.length==0){
    //       //this.emptystate=true;
    //     }
    // });


    //     selectedProjectTypeFunction(id: number) {
    // console.log(id)
    //         if (id === 1) {
    //           this.projectType = ProjectType.AllProjects;
    //             this.selectedProjectType = 'Active';
    //         this.projectChild.getAllProjects();
    //         } else if (id === 2) {
    //           this.projectType = ProjectType.ArchivedProjects;
    //             this.selectedProjectType = 'Archived';
    //              this.projectChild.getAllArchiveProjects();
    //         } else {
    //           this.projectType = ProjectType.DeletedProjects;
    //             this.selectedProjectType = 'Deleted';
    //              this.projectChild.getAllDeletedProjects();
    //         }
    //       }

    //     sectionToShowProjects = [{ id: 1, name: AppConsts.sectionNameForUserDisplayProject.allProject, desc: 'Active ' },
    //   { id: 2, name: AppConsts.sectionNameForUserDisplayProject.archiveProject, desc: 'Archived' },
    //   { id: 3, name: AppConsts.sectionNameForUserDisplayProject.deleteProject, desc: 'Deleted ' }];

    selectedProjectType = 'Active';
    onOpenChange(data: boolean): void {
        this.textForClass = data ? 'la-angle-up' : 'la-angle-down';
    }


    //** Check for Is login PErson is client or not
    isCheckForClientUser() {
        if (this._abpSessionServiceProxy.tenantId == null)
            return;
        if (this._abpSessionServiceProxy.tenantId == undefined)
            return;

        if (AppConsts.isCheckClient !== undefined) {
            this.isClient = AppConsts.isCheckClient;
        } else {
            this._userService.isCheckClient(this._abpSessionServiceProxy.userId, this._abpSessionServiceProxy.tenantId).subscribe(x => {
                this.isClient = x;
                AppConsts.isCheckClient = x;
            });

        }
    }


    selectedTabForClient(value: number) {

        // this._defaultLayoutService.showType.next(value);

        // abp.event.trigger('getClientResponse');

        // if (value === 1) {
        //     this._defaultLayoutService.clientSelectedHeading = 'ActiveClients';
        // }
        // if (value === 2) {
        //     this._defaultLayoutService.clientSelectedHeading = 'ArchivedClients';
        //     localStorage.setItem("testArc",'true');
        // }
        // if (value === 3) {
        //     this._defaultLayoutService.clientSelectedHeading = 'DeletedClients';
        // }
        this._defaultLayoutService.selectedTabForClient(value);
        this.router.navigate(['/app/main/client-new/client-new-managment'], { queryParams: { id: value } });
    }

    selectedTabForProject(value: number) {

        // this._defaultLayoutService.showType.next(value);

        // abp.event.trigger('getProjectResponse');
        this._defaultLayoutService.selectedTabForProject(value);
        this.router.navigate(['/app/main/projects-new/projects-new-management'], { queryParams: { id: value } });

        // if (value === 1) {
        //     this._defaultLayoutService.projectSelectedHeading = 'ActiveProjects';
        // }
        // if (value === 2) {
        //     this._defaultLayoutService.projectSelectedHeading = 'ArchivedProjects';
        //     localStorage.setItem("testProj",'true');
        // }
        // if (value === 3) {
        //     this._defaultLayoutService.projectSelectedHeading = 'DeletedProjects';
        // }
    }

    productServiceSelectionType(value: number) {

        this.productServiceSelectedTab == value;
        if (value === 1) {
            this.productServiceSelectionTypeValue = 'Products';
        }
        else {
            this.productServiceSelectionTypeValue = 'Services';
        }
    }

    productSelectionType(value: number) {

        this._defaultLayoutService.showProductType.next(value);
        abp.event.trigger('getProductResponse');

        if (value === 1) {
            this.productSelectionDropdownValue = 'ActiveProducts';

        } else if (value === 2) {
            this.productSelectionDropdownValue = 'ArchivedProducts';

        } else {
            this.productSelectionDropdownValue = 'DeletedProducts';

        }

    }

    serviceSelectionType(value: number) {

        this._defaultLayoutService.showServiceType.next(value);

        abp.event.trigger('getServiceResponse');

        if (value === 1) {
            this.serviceSelectionDropdownValue = 'ActiveServices';

        } else if (value === 2) {
            this.serviceSelectionDropdownValue = 'ArchivedServices';

        } else {
            this.serviceSelectionDropdownValue = 'DeletedServices';
        }

    }

    selectedUserTab(value: number) {
        // this._defaultLayoutService.showUserType.next(value);
        // abp.event.trigger('getUserResponse');
        return;
        this._defaultLayoutService.selectedUserTab(value);
        this.router.navigate(['/app/admin/users'], { queryParams: { id: value } });
        // if (value === 1) {

        //     this.userSelectedType = 'activeUsers';

        // } else if (value === 2) {

        //     this.userSelectedType = 'ArchivedUsers';

        // } else if (value === 3) {

        //     this.userSelectedType = 'DeletedUsers';

        // }
    }


    selectedTabDashboard(value: number) {
        this.uparrow = true;
        /*assigning value to the functions*/
        //this._defaultLayoutService.showDashboardType.next(value);
        //abp.event.trigger('getUserResponse');
        if (value == 0) {
            this.dashboardSelectedType = 'MyDashboard';
            /* this._defaultLayoutService.CheckDashboardChange(1);*/
        } else if (value == 1) {
            this.dashboardSelectedType = 'TeamDashboard';
            /* this._defaultLayoutService.CheckDashboardChange(2);*/

        }
        //}
        abp.event.trigger('selectedTabAdminDashboard', value);



    }

}

